import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import apiClient from './api-client';
const SCOPE = 'feedback';
const DETAIL = 'detail';
const keysFactory = {
    all: (financingProgram) => [{ scope: SCOPE, financingProgram }],
    allDetails: (financingProgram) => [{ scope: SCOPE, entity: DETAIL, financingProgram }],
    detail: (id, financingProgram) => [{ scope: SCOPE, entity: DETAIL, id, financingProgram }],
};
const createGetFeedback = (financingProgram) => {
    return async ({ queryKey: [{ id }] }) => {
        try {
            const response = await apiClient.get(`/${financingProgram}/creditApplication/${encodeURIComponent(id)}/CustomerFeedback`);
            return response.data;
        }
        catch {
            return null;
        }
    };
};
export function useGetFeedback(creditApplicationId, financingProgram) {
    const getFeedback = createGetFeedback(financingProgram);
    const { isFetching, data } = useQuery({
        queryKey: keysFactory.detail(creditApplicationId, financingProgram),
        queryFn: getFeedback,
        enabled: !!creditApplicationId,
    });
    return [data ?? null, isFetching];
}
const createSubmitFeedback = (financingProgram) => {
    return async (dto) => {
        const response = await apiClient.post(`${financingProgram}/creditApplication/${dto.creditApplicationId}/CustomerFeedback`, dto);
        const ret = response.data;
        ret.creditApplicationId = dto.creditApplicationId;
        return ret;
    };
};
export function useSubmitFeedback(financingProgram) {
    const queryClient = useQueryClient();
    const submitFeedback = createSubmitFeedback(financingProgram);
    const { mutateAsync, isPending, reset } = useMutation({
        mutationFn: submitFeedback,
        onSuccess: (data) => {
            queryClient.setQueryData(keysFactory.detail(data.creditApplicationId, financingProgram), data);
            return data;
        },
    });
    return [mutateAsync, isPending, reset];
}
